/**
 * =============================================================================
 * QIKIFY CART SYNC — Maminat
 * =============================================================================
 *
 * PROBLEMA QUE RESUELVE
 * ---------------------
 * Qikify Slide Cart detecta que se añadió algo al carrito "parcheando"
 * window.fetch y XMLHttpRequest. Cuando lo detecta, dispara los eventos
 * 'ajax-cart:added' / 'ajax-cart:changed' y ESO es lo único que abre el drawer.
 *
 * En esta tienda hay otra app (Essential Pre-Order & Presale) cuyo app-embed
 * hace lo mismo, pero al re-renderizar ejecuta un "cleanup" que RESTAURA el
 * window.fetch / XMLHttpRequest originales, borrando el parche de Qikify.
 * Según quién gane esa carrera en cada carga de página, Qikify se queda ciego:
 * el producto SÍ entra al carrito, pero el slide cart no se abre ni se refresca
 * hasta que cambias de página. De ahí que el fallo sea intermitente.
 *
 * SOLUCIÓN
 * --------
 * Este script instala su propio listener de /cart/add|change|update|clear
 * (replicando exactamente la lógica de Qikify: mismas regex, mismo debounce de
 * 200 ms, misma lista de URLs ignoradas) y dispara los mismos eventos.
 *
 * Se carga desde el <head> del tema, ANTES que los app embeds, para quedar
 * dentro del "snapshot" que hacen las otras apps y sobrevivir a sus cleanups.
 * Además incluye un watchdog que se reinstala si alguna app lo desplaza.
 *
 * Es puramente ADITIVO: no modifica ni reemplaza nada de Qikify. Si el parche
 * de Qikify sí sobrevive, los eventos duplicados se colapsan con el mismo
 * debounce de 200 ms que usa la app.
 *
 * Si algún día se desactiva la app "Essential Pre-Order & Presale" (y la de
 * "Essential Post-Purchase Upsell", que usa el mismo patrón), este archivo deja
 * de ser necesario, aunque no molesta dejarlo.
 * =============================================================================
 */

(function () {
    'use strict';

    if (window.__qscCartSyncInstalled) return;
    window.__qscCartSyncInstalled = true;

    // ─── CONFIGURACIÓN (espejo de las constantes internas de Qikify) ───────────
    var ADD_RE = /(\/cart\/add(\.js)?)/;
    var CHANGE_RE = /(\/cart\/(change|update|clear)(\.js)?)/;
    var SILENT_RE = /[?&]sc-silently-change-cart=true\b/;
    var IGNORE_URL = ['?qsc-shipping-protection', '?qbk-free-gift'];

    var EVENT_ADDED = 'ajax-cart:added';
    var EVENT_CHANGED = 'ajax-cart:changed';

    var DEBOUNCE = 200;       // mismo debounce que Qikify
    var WAIT_STEP = 250;      // reintento mientras Qikify termina de montar
    var WAIT_MAX = 8000;      // máximo que esperamos a Qikify (clicks muy tempranos)
    var HEAL_EVERY = 1000;    // cada cuánto revisa el watchdog
    var HEAL_TIMES = 20;      // cuántas revisiones hace (20 s de vida)
    var HEAL_MAX_REWRAPS = 5; // tope de reinstalaciones, por seguridad


    // ─── HELPERS ───────────────────────────────────────────────────────────────

    function isIgnored(url) {
        if (!url) return true;
        for (var i = 0; i < IGNORE_URL.length; i++) {
            if (String(url).indexOf(IGNORE_URL[i]) !== -1) return true;
        }
        return false;
    }

    function isSilent(url) {
        return !!url && SILENT_RE.test(String(url));
    }

    function qikifyReady() {
        return window.QIKIFY_STICKYCART_V2_SC_LOADED === true;
    }

    /**
     * Dispara el evento. Si Qikify todavía no montó (el usuario hizo click
     * apenas cargó la página) espera a que esté listo, hasta WAIT_MAX.
     */
    function emit(name) {
        if (qikifyReady()) {
            document.dispatchEvent(new Event(name));
            return;
        }
        var waited = 0;
        var iv = setInterval(function () {
            waited += WAIT_STEP;
            if (qikifyReady()) {
                clearInterval(iv);
                document.dispatchEvent(new Event(name));
            } else if (waited >= WAIT_MAX) {
                clearInterval(iv);
            }
        }, WAIT_STEP);
    }

    var addTimer = null;
    var changeTimer = null;

    function fireAdded() {
        clearTimeout(addTimer);
        addTimer = setTimeout(function () { emit(EVENT_ADDED); }, DEBOUNCE);
    }

    function fireChanged() {
        clearTimeout(changeTimer);
        changeTimer = setTimeout(function () { emit(EVENT_CHANGED); }, DEBOUNCE);
    }

    /**
     * Evalúa una petición ya completada y decide qué evento corresponde.
     */
    function handle(url, ok) {
        if (!ok || !url || isSilent(url)) return;
        var clean = String(url);

        if (ADD_RE.test(clean) && !isIgnored(clean)) {
            fireAdded();
            return;
        }
        if (CHANGE_RE.test(clean)) {
            fireChanged();
        }
    }


    // ─── PARCHE DE FETCH ───────────────────────────────────────────────────────

    var rewraps = 0;

    function wrapFetch() {
        var inner = window.fetch;
        if (typeof inner !== 'function') return;

        function qscSyncFetch() {
            var args = arguments;
            var url = (args[0] && args[0].url) || args[0] || '';
            var promise = inner.apply(this, args);

            // Observamos la promesa en paralelo: NO devolvemos la encadenada,
            // para no alterar la original ni tragarnos errores de quien llamó.
            if (promise && typeof promise.then === 'function') {
                promise.then(function (res) {
                    try {
                        handle(res && res.url ? res.url : url, !res || res.ok !== false);
                    } catch (e) { /* noop */ }
                }, function () { /* noop */ });
            }

            return promise;
        }

        qscSyncFetch.__qscSync = true;
        window.fetch = qscSyncFetch;
    }


    // ─── PARCHE DE XMLHttpRequest ──────────────────────────────────────────────

    function wrapXHR() {
        var open = XMLHttpRequest.prototype.open;
        if (typeof open !== 'function' || open.__qscSync) return;

        function qscSyncOpen(method, url) {
            this.__qscUrl = url;
            this.addEventListener('load', function () {
                try {
                    var ok = this.status >= 200 && this.status < 300;
                    handle(this.responseURL || this.__qscUrl, ok);
                } catch (e) { /* noop */ }
            });
            return open.apply(this, arguments);
        }

        qscSyncOpen.__qscSync = true;
        XMLHttpRequest.prototype.open = qscSyncOpen;
    }


    // ─── WATCHDOG ──────────────────────────────────────────────────────────────
    // Si otra app nos desplaza (nos envuelve o nos borra), volvemos a instalarnos.

    function startWatchdog() {
        var checks = 0;
        var iv = setInterval(function () {
            checks++;

            if (!window.fetch || !window.fetch.__qscSync) {
                if (rewraps < HEAL_MAX_REWRAPS) {
                    rewraps++;
                    wrapFetch();
                }
            }
            if (!XMLHttpRequest.prototype.open.__qscSync) {
                wrapXHR();
            }

            if (checks >= HEAL_TIMES) clearInterval(iv);
        }, HEAL_EVERY);
    }


    // ─── ARRANQUE ──────────────────────────────────────────────────────────────

    wrapFetch();
    wrapXHR();
    startWatchdog();
})();
